import { circlePrompts } from './circles.ts';

/** French volume prompts (ADR 0095 §3, §5). */
export const volumePrompts = {
    countCubes: () => `Combien de cubes unités remplissent cette boîte ?`,
    edgeLengths: () => `Quel est le volume ?`,
    twoBoxes: () => `Quel est le volume de ce solide ?`,
    surfaceAreaNet: () => `Ce patron se plie en une boîte. Quelle est son aire totale ?`,
    surfaceAreaBox: () => `Quelle est l'aire totale de cette boîte ?`,
    missingEdge: (volume: string) => `Le volume est de ${volume}. Combien mesure l'arête manquante ?`,
    /** ADR 0140 §4: the solid is named, and the pi sentence is Circles'. */
    cylinder: () => `Quel est le volume du cylindre ? ${circlePrompts.piSentence()}`,
    cone: () => `Quel est le volume du cône ? ${circlePrompts.piSentence()}`,
    sphere: () => `Quel est le volume de la sphère ? ${circlePrompts.piSentence()}`,
    /** A number of hundredths as the sheet writes it: a comma. */
    decimal: circlePrompts.decimal,
    cubes: (count: number) => `${count} cubes`,
};
